import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const signes = [
  "Cordon cassé ou effiloché",
  "Enrouleur bloqué ou grippé",
  "Volet qui retombe après montée",
  "Mécanisme qui patine sans actionner le volet",
];

export default function Signes() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold mb-5">
              Signes que le remplacement est nécessaire
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Un cordon ou un enrouleur de volet roulant a une durée de vie limitée. L&apos;usure progressive, l&apos;exposition au soleil ou une tension excessive peuvent l&apos;endommager. Voici les signes qui indiquent qu&apos;il est temps de faire intervenir un professionnel pour le remplacement.
            </p>
            <ul className="space-y-3 mb-8">
              {signes.map((signe) => (
                <li key={signe} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#E8734A]/10 shrink-0">
                    <i className="ri-check-line text-[#E8734A] text-sm"></i>
                  </span>
                  <span className="text-[#1B2A4A] text-base font-medium">{signe}</span>
                </li>
              ))}
            </ul>

            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#E8734A] text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-[#E8734A]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          <div className="order-1 lg:order-2 relative rounded-2xl overflow-hidden">
            <ImagePlaceholder src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20worn%20and%20frayed%20white%20roller%20shutter%20pull%20cord%20hanging%20from%20a%20shutter%20box%20showing%20clear%20signs%20of%20damage%20and%20needing%20replacement%20in%20a%20residential%20interior%20clean%20daylight%20professional%20photography%20warm%20neutral%20tones&width=700&height=520&seq=cord-signes&orientation=landscape" alt="Cordon de volet roulant usé à remplacer" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}